import { keccak256, toHex, type Hash as ViemHash } from 'viem'

import { assert } from '../assert/assert.js'
import { IRandom } from '../random/index.js'
import { Hex } from './Hex.js'
import { Opaque } from './Opaque.js'

/**
 * 256 bit hash value i.e. 0x8a214de42955bf98e545d2e37df91e0da9b1c37d54d0b1fb6fbd584b91a4790f
 */
export type Hash256 = Opaque<ViemHash, 'Hash'>
export function Hash256(hash: string): Hash256 {
  assert(hash.match(/^0x[0-9a-fA-F]{64}$/), `Invalid hash: ${hash}`)
  return hash as Hash256
}

Hash256.random = (ascii = '', random?: IRandom): Hash256 => {
  return Hash256(Hex.random(ascii, 64, random))
}

Hash256.fromText = (text: string): Hash256 => {
  return Hash256(keccak256(toHex(text)))
}

Hash256.formatShort = (hash: Hash256): string => {
  return `${hash.slice(0, 8)}...${hash.slice(-8)}`
}
